import classnames from "classnames";
import { CustomSelect, TextField, TextGroup, TextLabel } from "../../Styled";
import {
  DIGIKEY_PROXY_OPTIONS,
  DIGIKEY_PROXY_SETTING_KEY,
  SETTING_VALUE_TYPES,
  getSettingValueInputType,
  normalizeSettingType,
} from "../../../constants/settingValueTypes";

const SettingValueFields = ({ fillData, errors, requiredField, change }) => {
  const settingType = normalizeSettingType(fillData.setting_type);
  const inputType = getSettingValueInputType(settingType);
  const requiredKeys = Object.keys(requiredField || {});

  return (
    <>
      <TextGroup className={classnames({ error: errors.setting_type })}>
        <TextLabel>
          Value Type {requiredKeys.includes("setting_type") ? " *" : ""}
        </TextLabel>
        <CustomSelect>
          <TextField
            as="select"
            name="setting_type"
            value={settingType}
            onChange={change}
          >
            {SETTING_VALUE_TYPES.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        </CustomSelect>
        {errors.setting_type ? (
          <span className="error-text">{errors.setting_type}</span>
        ) : null}
      </TextGroup>
      <TextGroup className={classnames({ error: errors.setting_value })}>
        <TextLabel>
          Setting Value {requiredKeys.includes("setting_value") ? " *" : ""}
        </TextLabel>
        {fillData.setting_key === DIGIKEY_PROXY_SETTING_KEY ? (
          <CustomSelect>
            <TextField
              as="select"
              name="setting_value"
              value={fillData.setting_value || ""}
              onChange={change}
            >
              {DIGIKEY_PROXY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </CustomSelect>
        ) : settingType === "BOOLEAN" ? (
          <CustomSelect>
            <TextField
              as="select"
              name="setting_value"
              value={fillData.setting_value || ""}
              onChange={change}
            >
              <option value="">Select</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </TextField>
          </CustomSelect>
        ) : (
          <div
            className={classnames("setting-value-field", {
              "has-prefix": settingType === "PRICE",
              "has-suffix": settingType === "PERCENTAGE",
            })}
          >
            {settingType === "PRICE" ? (
              <span className="setting-value-prefix">$</span>
            ) : null}
            <TextField
              type={inputType}
              name="setting_value"
              placeholder={
                settingType === "PRICE"
                  ? "0.00"
                  : settingType === "PERCENTAGE"
                  ? "0"
                  : "Enter setting value"
              }
              value={fillData.setting_value || ""}
              onChange={change}
              step={
                settingType === "INTEGER"
                  ? "1"
                  : inputType === "number"
                  ? "any"
                  : undefined
              }
            />
            {settingType === "PERCENTAGE" ? (
              <span className="setting-value-suffix">%</span>
            ) : null}
          </div>
        )}
        {errors.setting_value ? (
          <span className="error-text">{errors.setting_value}</span>
        ) : null}
      </TextGroup>
    </>
  );
};

export default SettingValueFields;
